import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import TableActions from "../../../components/Common/TableActions";
import {
  PROMOCODE_LIST,
  DELETE_PROMOCODE,
  PROMOCODE_STATUS_CHANGE,
  PROMOTION_LIST,
  DELETE_PROMOTION,
} from "../../../services/ApiCalls";
import dataHandler from "../../../hooks/dataHandler";
import moment from "moment";
import Toggle from "../../../components/Common/Toggle";
import Filter from "../../../components/Common/Filter";
import {
  activeInactiveOptions,
  defaultDeleteModelState,
  promotionListFilterOptions,
} from "../../../utilities/const";

import u1 from "../../../Assets/images/authBg.png";
import { Link } from "react-router-dom";
// import { CstmPagination } from "../../../components/Common/Common";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import CustomPagination from "../../../components/Common/CustomPagination";
import { useTranslation } from "react-i18next";
// import { useTranslation } from "react-i18next";

const PromotionList = () => {
  const { t } = useTranslation();
  const {
    setBody,
    statusChangeHandler,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    setCommisionModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: PROMOTION_LIST,
    extraBody: { ROLE: "PROMOTION" },

  });

  const column = [
    {
      head: t("promotion.columns.srNo"),
      accessor: "#",
      component: (item, key) => {
        return <>{key < 9 ? `0${key + 1}` : key + 1}</>;
      },
    },
    {
      head: t("promotion.columns.image"),
      accessor: "image",
      component: (item) => {
        return (
          <>
            <img
              height={60}
              src={item?.image?.link}
              alt={item?.name}
            />
          </>
        );
      },
    },
    {
      head: t("promotion.columns.name"),
      accessor: "name",
    },
    {
      head: t("promotion.columns.description"),
      accessor: "description",
    },
    {
      head: t("promotion.columns.status"),
      accessor: "",
      isComponent: true,
      component: (item, ind) => (
        <span
          className={`px-2 py-0 text-uppercase rounded ${item?.status === "active"
            ? "bg-success text-white"
            : "bg-danger text-white"
            }`}
        >
          {item?.status}
        </span>
      ),
    },

    {
      head: t("promotion.columns.createdAt"),
      accessor: "createdAt",
      component: (item, key) => {
        return (
          <>
            <p>{moment(item?.createdAt).format("MM-DD-YYYY")}</p>
          </>
        );
      },
    },

    {
      head: t("promotion.columns.action"),
      accessor: "Action",
      component: (item) => {
        console.log(item, "item");
        return (
          <TableActions
            editUrl={`/edit-promotion/${item._id}`}
            setDeleteModel={() =>
              setDeleteModel({ show: true, dumpId: item?._id })
            }
            viewLink={`/promotion/detail/${item._id}`}
          />
        );
      },
    },
  ];

  const [confirmation, setConfirmation] = useState();
  const handleConfirmation = () => setConfirmation(!confirmation);
  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel((p) => defaultDeleteModelState)}
        confirmHandler={() =>
          deleteHandler(() => DELETE_PROMOTION({ _id: deleteModel.dumpId }))
        }
      />
      <section className="promocode py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                {t("promotion.title")}

              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-end justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    setBody={setBody}
                    searchHandler={searchHandler}
                    statusFilterOptionArr={promotionListFilterOptions}
                  />
                </div>
                <div className="right d-flex gap-3">
                  <Link
                    to="/add-promotion"
                    className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                    style={{ height: 40, minWidth: 100, fontSize: 12 }}
                  >
                    {t("promotion.addPromotion")}
                  </Link>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PromotionList;
